export const getFaqs = (t) => [
  { question: t('faq.q13.question'), answer: t('faq.q13.answer') },
  { question: t('faq.q14.question'), answer: t('faq.q14.answer') },
  { question: t('faq.q15.question'), answer: t('faq.q15.answer') },
  { question: t('faq.q16.question'), answer: t('faq.q16.answer') },
  { question: t('faq.q17.question'), answer: t('faq.q17.answer') },
  { question: t('faq.q18.question'), answer: t('faq.q18.answer') },
  { question: t('faq.q19.question'), answer: t('faq.q19.answer') },
  { question: t('faq.q20.question'), answer: t('faq.q20.answer') },
  { question: t('faq.q21.question'), answer: t('faq.q21.answer') },
  { question: t('faq.q22.question'), answer: t('faq.q22.answer') },
  { question: t('faq.q23.question'), answer: t('faq.q23.answer') },
  { question: t('faq.q1.question'), answer: t('faq.q1.answer') },
  { question: t('faq.q2.question'), answer: t('faq.q2.answer') },
  { question: t('faq.q3.question'), answer: t('faq.q3.answer') },
  { question: t('faq.q4.question'), answer: t('faq.q4.answer') },
  { question: t('faq.q5.question'), answer: t('faq.q5.answer') },
  { question: t('faq.q6.question'), answer: t('faq.q6.answer') },
  { question: t('faq.q7.question'), answer: t('faq.q7.answer') },
  { question: t('faq.q8.question'), answer: t('faq.q8.answer') },
  { question: t('faq.q9.question'), answer: t('faq.q9.answer') },
  { question: t('faq.q10.question'), answer: t('faq.q10.answer') },
  { question: t('faq.q11.question'), answer: t('faq.q11.answer') },
  { question: t('faq.q12.question'), answer: t('faq.q12.answer') }
];
